export const createResume = resume => {
  return (dispatch, getState, { getFirebase, getFirestore }) => {
    // Make async call to database
    const firestore = getFirestore();
    const profile = getState().firebase.profile;
    const authorId = getState().firebase.auth.uid;
    firestore
      .collection("resumes")
      .add({
        ...resume,
        applicantFirstName: profile.firstName,
        applicantLastName: profile.lastName,
        authorId: authorId,
        createdAt: new Date()
      })
      .then(() => {
        dispatch({ type: "CREATE_RESUME", resume });
      })
      .catch(err => {
        dispatch({ type: "CREATE_RESUME_ERROR", err });
      });
  };
};
